module.exports = __webpack_public_path__ + "static/media/velour7E.93ef08c7.jpg";